<template lang="pug">
el-dialog#modal-cadastrar-monitoramento-agricola(
    width='500px',
    :visible.sync='show',
    :before-close='fechar',
    :close-on-click-modal='false',
    :close-on-press-escape='false',
    :destroy-on-close='true',
    close='fechar'
)
    span(slot='title')
        h2.font-weight-bold.pb-4 {{ $t('mensagens.monitoramentoAgricola.novoMonitoramento.baseHeader.titulo') }}

    el-form.formContainer.w-100.mb-3.p-0(
        :model='dadosMonitoramento',
        :rules='rules',
        ref='formularioAreasMonitoramento'
    )
        el-form-item.my-3(prop='idSafra', :label="$t('mensagens.territorio.cicloAno')")
                el-select.w-100(
                    v-model='dadosMonitoramento.idSafra',
                    :placeholder="$t('mensagens.territorio.selecione')",
                    value-key='descricao'
                )
                    el-option(
                        v-for='ciclo in cicloAno',
                        :key='"cicloAno" + ciclo.descricao',
                        :value='ciclo.id',
                        :label='ciclo.descricao'
                    ) {{ ciclo.descricao }}

        el-form-item.my-3(prop='cultura', :label="$t('mensagens.territorio.culturaEsperada')")
            el-select.w-100(
                v-model='dadosMonitoramento.cultura',
                :placeholder="$t('mensagens.territorio.selecione')",
                clearable
            )
                el-option(
                    v-for='cultura in culturas',
                    :key='"cultura" + cultura.id',
                    :value='cultura.id',
                    :label='internacionalizarCulturas(cultura.nome)'
                ) {{ internacionalizarCulturas(cultura.nome) }}

        el-form-item.my-3(
            prop='dataPlantio',
            :label="$t('mensagens.territorio.dataPlantioEsperada')"
        )
            el-date-picker.w-100(
                :disabled="!dadosMonitoramento.cultura"
                v-model='dadosMonitoramento.dataPlantio',
                type='date',
                format='dd/MM/yyyy',
                value-format='yyyy-MM-dd',
                placeholder='',
                clearable
            )

        el-form-item.my-3.inline(
            prop='areaDoPlantio',
            :label="$t('mensagens.territorio.areaPlantioEsperada')"
        )
            el-input.custom-input(
                :disabled="!dadosMonitoramento.cultura"
                v-model="dadosMonitoramento.areaDoPlantio"
                :placeholder="formatarNumero(0)"
                @input="corrigirEntrada"
                @blur="aplicarFormatacao"
            )

        el-form-item.my-3.inline(
            prop='produtividade',
            :label="$t('mensagens.territorio.produtividadeEsperada') + formatarUnidadeDeProdutividade()"
        )
            el-input.custom-input(
                :disabled="!dadosMonitoramento.cultura"
                v-model="dadosMonitoramento.produtividade"
                :placeholder="formatarNumero(0)"
                @input="corrigirEntradaProdutividade"
                @blur="aplicarFormatacaoProdutividade"
            )

        el-form-item.my-1.inline(
            prop='cultivar',
            :label="$t('mensagens.territorio.cultivar')"
        )
            el-input(
                v-model='dadosMonitoramento.cultivar',
                :placeholder="$t('mensagens.territorio.labels.cultivar')",
                maxlength='100'
            )

        el-form-item.my-1.inline(
            prop='biotecnologia',
            :label="$t('mensagens.territorio.biotecnologia')"
        )
            el-input(
                v-model='dadosMonitoramento.biotecnologia',
                :placeholder="$t('mensagens.territorio.labels.biotecnologia')",
                maxlength='100'
            )

    div(slot='footer')
        .buttons
            BaseButton(size='mini', @click='fechar')
                | {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(
                type='primary',
                size='mini',
                @click='confirmarMonitoramento'
            )
                | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import CulturaService from '@/services/CulturaService';
import UtilsService from '@/services/UtilsService';
import { CULTURAS } from '@/utils/TipoCultura';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalCadastrarMonitoramentoAgricolaParaguai',
    components: {
        BaseButton
    },
    emits: ['cadastrarMonitoramentoAgricola'],
    props: {
        show: {
            type: Boolean,
            default: () => false
        },
        territoriosSelecionados: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            algodao: null,
            rules: {
                idSafra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'blur'
                    }
                ],
                cultivar: [
                    { validator: this.checkRuleCultivar, trigger: 'blur' }
                ],
                biotecnologia: [
                    { validator: this.checkRuleBiotecnologia, trigger: 'blur' }
                ]
            },
            culturas: [],
            culturasListagem: [ CULTURAS.SOJA.codigo, CULTURAS.MILHO.codigo, CULTURAS.ALGODAO.codigo ],
            cicloAno: [],
            dadosMonitoramento: {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0,
                cultivar: null,
                biotecnologia: null
            }
        };
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
    },

    watch: {
        'dadosMonitoramento.areaDoPlantio': {
            immediate: true,
            handler(newValue) {
                this.areaDoPlantioLocal = this.formatarNumero(newValue);
            }
        },
        'dadosMonitoramento.produtividade': {
            immediate: true,
            handler(newValue) {
                this.produtividadeLocal = this.formatarNumero(newValue);
            }
        }
    },

    methods: {
        buscarCulturas() {
            CulturaService.buscarPorCodigo(this.culturasListagem)
                .then(({ data }) => {
                    setTimeout(() => {
                        Object.keys(data).forEach(item => {
                            this.culturas.push(data[item]);
                            this.culturas.sort((a, b) =>
                                a.nome.localeCompare(b.nome)
                            );
                            if (data[item].codigo === CULTURAS.ALGODAO.codigo) {
                                this.algodao = data[item].id;
                            }
                        });
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de culturas.'
                    });
                    throw error;
                });
        },
        buscarSafras() {
            UtilsService.getSafras().then(response => {
                if (response.status === 200) {
                    this.cicloAno = response.data;
                } else {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar safras'
                    });
                }
            });
        },
        checkRuleCultivar(rule, value, callback) {
            const cultivar = this.dadosMonitoramento.cultivar;
            const regex = /^[^+%=$&*@]+$/;
            if (cultivar !== '' && cultivar !== null && !regex.test(cultivar)) {
                return callback(
                    new Error(this.$t('mensagens.territorio.erroCaractereInvalido'))
                );
            }
            callback();
        },
        checkRuleBiotecnologia(rule, value, callback) {
            const biotecnologia = this.dadosMonitoramento.biotecnologia;
            const regex = /^[^+%=$&*@]+$/;
            if (biotecnologia !== '' && biotecnologia !== null && !regex.test(biotecnologia)) {
                return callback(
                    new Error(this.$t('mensagens.territorio.erroCaractereInvalido'))
                );
            }
            callback();
        },
        fechar() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        confirmarMonitoramento() {
            this.$refs.formularioAreasMonitoramento.validate(async valid => {
                if (valid) {
                    const areasMonitoramento = [];

                    this.territoriosSelecionados.forEach(({ idTerritorio, tipoMonitoramento }) => {
                        areasMonitoramento.push({
                            idTerritorio,
                            tipoMonitoramento,
                            ...this.dadosMonitoramento,
                            areaDoPlantio: this.parsingNumero(this.dadosMonitoramento.areaDoPlantio),
                            produtividade: this.parsingNumero(this.dadosMonitoramento.produtividade)
                        });
                    });

                    this.$emit('cadastrarMonitoramentoAgricola', areasMonitoramento);
                    this.fechar();
                }
            });
        },
        clearFields() {
            this.dadosMonitoramento = {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0,
                cultivar: null,
                biotecnologia: null
            };
        },
        formatarUnidadeDeProdutividade() {
            return this.dadosMonitoramento.cultura !== null && this.dadosMonitoramento.cultura === this.algodao ? ' (@/ha)' : ' (t/ha)';
        },
        internacionalizarCulturas(cultura) {
            const culturaFormatada = cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            const culturaFormatadaSemEspacos = culturaFormatada.replace(/\s+/g, '-');
            return this.$t(`mensagens.cultura.${culturaFormatadaSemEspacos}`);
        },
        corrigirEntrada(event) {
            if (!event || !event.target) return;
            
            let value = event.target.value || '0,00';

            const idioma = this.$i18n.locale;

            if (idioma === 'pt-BR' || idioma === 'es') {
                value = value.replace(/[^0-9,]/g, '');
                value = value.replace(/\./g, ',');
            } else {
                value = value.replace(/[^0-9.]/g, '');
                value = value.replace(/,/g, '.');
            }

            this.dadosMonitoramento.areaDoPlantio = value;
        },

        corrigirEntradaProdutividade(event) {
            if (!event || !event.target) return;
            
            let value = event.target.value || '0,00';

            const idioma = this.$i18n.locale;

            if (idioma === 'pt-BR' || idioma === 'es') {
                value = value.replace(/[^0-9,]/g, '');
                value = value.replace(/\./g, ',');
            } else {
                value = value.replace(/[^0-9.]/g, '');
                value = value.replace(/,/g, '.');
            }

            this.dadosMonitoramento.produtividade = value;
        },

        aplicarFormatacao() {
            this.dadosMonitoramento.areaDoPlantio = this.formatarNumero(
                this.parsingNumero(this.dadosMonitoramento.areaDoPlantio)
            );
        },

        aplicarFormatacaoProdutividade() {
            this.dadosMonitoramento.produtividade = this.formatarNumero(
                this.parsingNumero(this.dadosMonitoramento.produtividade)
            );
        },

        formatarNumero(value) {
            if (typeof value !== 'number' || isNaN(value)) return '0,00';

            const idioma = this.$i18n.locale;
            return idioma === 'pt-BR' || idioma === 'es'
                ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        parsingNumero(value) {
            if (!value) return 0;

            const idioma = this.$i18n.locale;
            let numero;

            if (idioma === 'pt-BR' || idioma === 'es') {
                numero = parseFloat(value.replace(/\./g, '').replace(',', '.')) || 0;
            } else {
                numero = parseFloat(value.replace(/,/g, '')) || 0;
            }

            return Number(numero.toFixed(2));
        }
    }
};
</script>

<style lang="scss">
#modal-cadastrar-monitoramento-agricola {
    border-radius: 5px;
    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }
    .el-dialog__body {
        padding: 0 20px 30px;
        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }
    }
    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }
    .custom-input {
        width: 180px;
    }
    .custom-input input {
        text-align: center;
    }
}
</style>
